/* audit_policy_passed.icon.svg.js */

module.exports = {
    icon: `<svg viewBox="0 0 19 19" preserveAspectRatio="none"><path class="foreground-gl" d="M9.3,17.3L9.3,17.3c-0.3,0-0.6-0.1-0.8-0.4l-3.2-3.6c-0.4-0.5-0.3-1.2,0.1-1.6c0.5-0.4,1.2-0.4,1.6,0.1
\t\tl2.4,2.7L16,7.6c0.4-0.4,1.1-0.5,1.6,0c0.4,0.4,0.5,1.1,0,1.6l-7.4,7.7C9.9,17.1,9.6,17.3,9.3,17.3z"/><path class="foreground-gl" d="M13.7,1.8h-2.9C10.5,0.8,9.6,0,8.4,0S6.3,0.8,6,1.8H3.2c-1,0-1.7,0.8-1.7,1.7v13.3c0,1,0.8,1.7,1.7,1.7h4
\t\tc-0.2-0.1-0.3-0.1-0.6-0.3C6.3,18,6.1,17.7,6,17.4H3.4c-0.3,0-0.7-0.3-0.7-0.6V3.6C2.7,3.2,2.9,3,3.3,3h0.9c0.1,0.7,0.3,2,1.4,2H11
\t\tc1.2,0,1.4-1.3,1.4-2h1.3c0.3,0,0.6,0.3,0.6,0.6v3.2l1.2-1V3.6C15.5,2.6,14.7,1.8,13.7,1.8z M6.9,2.5C6.9,1.7,7.6,1,8.4,1
\t\tC9.3,1,10,1.7,10,2.5v0.3H6.9C6.9,2.7,6.9,2.6,6.9,2.5z"/>
</svg>`
};
